import { CalendarCell } from '@/ui/date-picker-panel';

export const WEEK_DAYS = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];

export const monthLabelFormatter = new Intl.DateTimeFormat('ru-RU', {
    month: 'long',
    year: 'numeric',
});

export const normalizeDate = (date: Date) => new Date(date.getFullYear(), date.getMonth(), date.getDate());

export const toMonthStart = (date: Date) => new Date(date.getFullYear(), date.getMonth(), 1);

export const pad = (value: number) => String(value).padStart(2, '0');

export const formatIsoDate = (date: Date) => {
    const normalized = normalizeDate(date);
    return `${normalized.getFullYear()}-${pad(normalized.getMonth() + 1)}-${pad(normalized.getDate())}`;
};

export const parseIsoDate = (value: string) => {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
    if (!match) return null;

    const year = Number(match[1]);
    const month = Number(match[2]);
    const day = Number(match[3]);
    const parsed = new Date(year, month - 1, day);

    if (parsed.getFullYear() !== year || parsed.getMonth() !== month - 1 || parsed.getDate() !== day) {
        return null;
    }

    return parsed;
};

export const buildCalendarDays = (calendarMonth: Date): CalendarCell[] => {
    const year = calendarMonth.getFullYear();
    const month = calendarMonth.getMonth();
    const monthStart = new Date(year, month, 1);
    const firstWeekdayOffset = (monthStart.getDay() + 6) % 7;

    const cells: CalendarCell[] = [];
    for (let index = 0; index < 42; index += 1) {
        const cellDate = new Date(year, month, index - firstWeekdayOffset + 1);

        cells.push({
            date: cellDate,
            iso: formatIsoDate(cellDate),
            isCurrentMonth: cellDate.getMonth() === month,
        });
    }

    return cells;
};
